import React from "react";
import axios from "axios"; // <-- added
import Dropdown from "./Dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { PiBellRingingDuotone, PiHeartbeatDuotone } from "react-icons/pi";
import { ImNotification } from "react-icons/im";
import { loadDecrypted } from "Common Usage/localStorageUtils";

const Navbar = (props) => {
  const staffData = loadDecrypted("HeartConnect-StaffData");

  const { onOpenSidenav, brandText } = props;
  let navigate = useNavigate();
  const avatar =
    "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671142.jpg?size=338&ext=jpg&ga=GA1.1.2116175301.1719360000&semt=ais_user";

  // Logout handler with staff activity logging
  const handleLogout = async () => {
    // Prepare log data
    const staffId = staffData?._id || staffData?.id || "";
    const staffName = staffData?.fullName || staffData?.name || "Unknown";

    if (staffId) {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
          {
            staff: staffId,
            action: "LOGOUT",
            description: `Staff ${staffName} logged out`,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      } catch (logErr) {
        // Log failure should not interrupt logout flow
        console.error("Failed to create staff activity log:", logErr);
      }
    }

    // Clear local storage and redirect to login
    localStorage.clear();
    navigate("/auth/sign-in");
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="text-2xl font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <span
          className="flex cursor-pointer text-xl text-gray-600 hover:text-[#c51369] xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-6 w-6" />
        </span>

        {/* start Notification */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <PiBellRingingDuotone className="h-6 w-6 text-gray-600 hover:text-[#c51369]" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  Mark all read
                </p>
              </div>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <ImNotification />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New: Heart connect
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new notification is available!
                  </p>
                </div>
              </button>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        <Dropdown
          button={
            <p className="cursor-pointer">
              <PiHeartbeatDuotone className="h-6 w-6 text-gray-600 hover:text-[#c51369]" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 tracking-wide shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              Hello, Heart💝
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />

        {/* Profile & Dropdown */}
        <div className="flex items-center space-x-2">
          <div className="space-y-[-4px] text-end">
            <div className="text-md font-semibold capitalize tracking-wide text-navy-700">
              {staffData?.fullName}
            </div>
            <div className="text-sm font-medium capitalize tracking-wide text-[#c51369]">
              {staffData?.rolePermission?.rolename}
            </div>
          </div>

          <Dropdown
            button={
              <img
                className="h-10 w-10 cursor-pointer rounded-full"
                src={staffData?.selected_Avatar || avatar}
                alt="profile-img"
              />
            }
            children={
              <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
                <div className="p-4">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-bold tracking-wide text-navy-700 dark:text-white">
                      👋 Hey, {staffData?.fullName}
                    </p>{" "}
                  </div>
                </div>
                <div className="h-px w-full bg-gray-200" />

                <div className="flex flex-col p-4 tracking-wide">
                  <div
                    onClick={() => navigate("/admin/my-profile")}
                    className="text-md cursor-pointer rounded-lg py-2 text-center text-navy-700 hover:bg-[#c51369] hover:text-white"
                  >
                    My Profile Settings
                  </div>

                  <div
                    onClick={handleLogout} // <-- updated logout handler
                    className="text-md cursor-pointer rounded-lg py-2 text-center text-red-600 hover:bg-[#c51369] hover:text-white"
                  >
                    Log Out
                  </div>
                </div>
              </div>
            }
            classNames={"py-2 top-8 -left-[180px] w-max"}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;





// import React from "react";
// import Dropdown from "./Dropdown";
// import { FiAlignJustify } from "react-icons/fi";
// import { Link, useNavigate } from "react-router-dom";
// import { PiBellRingingDuotone, PiHeartbeatDuotone } from "react-icons/pi";
// import { ImNotification } from "react-icons/im";
// import { loadDecrypted } from "Common Usage/localStorageUtils";

// const Navbar = (props) => {
//   const staffData = loadDecrypted("HeartConnect-StaffData");

//   const { onOpenSidenav, brandText } = props;
//   let navigate = useNavigate();
//   const avatar =
//     "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671142.jpg?size=338&ext=jpg&ga=GA1.1.2116175301.1719360000&semt=ais_user";

//   return (
//     <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
//       <div className="ml-[6px]">
//         <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
//           <Link
//             to="#"
//             className="text-2xl font-bold capitalize hover:text-navy-700 dark:hover:text-white"
//           >
//             {brandText}
//           </Link>
//         </p>
//       </div>

//       <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
//         <span
//           className="flex cursor-pointer text-xl text-gray-600 hover:text-[#c51369] xl:hidden"
//           onClick={onOpenSidenav}
//         >
//           <FiAlignJustify className="h-6 w-6" />
//         </span>

//         {/* start Notification */}
//         <Dropdown
//           button={
//             <p className="cursor-pointer">
//               <PiBellRingingDuotone className="h-6 w-6 text-gray-600 hover:text-[#c51369]" />
//             </p>
//           }
//           animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
//           children={
//             <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
//               <div className="flex items-center justify-between">
//                 <p className="text-base font-bold text-navy-700 dark:text-white">
//                   Notification
//                 </p>
//                 <p className="text-sm font-bold text-navy-700 dark:text-white">
//                   Mark all read
//                 </p>
//               </div>

//               <button className="flex w-full items-center">
//                 <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
//                   <ImNotification />
//                 </div>
//                 <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
//                   <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
//                     New: Heart connect
//                   </p>
//                   <p className="font-base text-left text-xs text-gray-900 dark:text-white">
//                     A new notification is available!
//                   </p>
//                 </div>
//               </button>
//             </div>
//           }
//           classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
//         />

//         <Dropdown
//           button={
//             <p className="cursor-pointer">
//               <PiHeartbeatDuotone className="h-6 w-6 text-gray-600 hover:text-[#c51369]" />
//             </p>
//           }
//           children={
//             <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 tracking-wide shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
//               Hello, Heart💝
//             </div>
//           }
//           classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
//           animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
//         />

//         {/* Profile & Dropdown */}
//         <div className="flex items-center space-x-2">
//           <div className="space-y-[-4px] text-end">
//             <div className="text-md font-semibold capitalize tracking-wide text-navy-700">
//               {staffData?.fullName}
//             </div>
//             <div className="text-sm font-medium capitalize tracking-wide text-[#c51369]">
//               {staffData?.rolePermission?.rolename}
//             </div>
//           </div>

//           <Dropdown
//             button={
//               <img
//                 className="h-10 w-10 cursor-pointer rounded-full"
//                 src={staffData?.selected_Avatar || avatar}
//                 alt="profile-img"
//               />
//             }
//             children={
//               <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
//                 <div className="p-4">
//                   <div className="flex items-center gap-2">
//                     <p className="text-sm font-bold tracking-wide text-navy-700 dark:text-white">
//                       👋 Hey, {staffData?.fullName}
//                     </p>{" "}
//                   </div>
//                 </div>
//                 <div className="h-px w-full bg-gray-200" />

//                 <div className="flex flex-col p-4 tracking-wide">
//                   <div
//                     onClick={() => navigate("/admin/my-profile")}
//                     className="text-md cursor-pointer rounded-lg py-2 text-center text-navy-700 hover:bg-[#c51369] hover:text-white"
//                   >
//                     My Profile Settings
//                   </div>

//                   <div
//                     onClick={() => {
//                       navigate("/auth/sign-in");
//                       localStorage.clear();
//                     }}
//                     className="text-md cursor-pointer rounded-lg py-2 text-center text-red-600 hover:bg-[#c51369] hover:text-white"
//                   >
//                     Log Out
//                   </div>
//                 </div>
//               </div>
//             }
//             classNames={"py-2 top-8 -left-[180px] w-max"}
//           />
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
